import { render, staticRenderFns } from "./ChatHistoryPage.vue?vue&type=template&id=04fb5218&scoped=true"
import script from "./ChatHistoryPage.vue?vue&type=script&lang=js"
export * from "./ChatHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./ChatHistoryPage.vue?vue&type=style&index=0&id=04fb5218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb5218",
  null
  
)

export default component.exports